var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94,
    filter: "url(#filter0_dd_468_10249)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_468_10249",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z",
    fill: "url(#paint0_linear_468_10249)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25M53 25M53 25M5 25M29 1M53 25M29 49M5 25M29 49V47C16.8497 47 7 37.1503 7 25H5H3C3 39.3594 14.6406 51 29 51V49ZM53 25H51C51 37.1503 41.1503 47 29 47V49V51C43.3594 51 55 39.3594 55 25H53ZM29 1V3C41.1503 3 51 12.8497 51 25H53H55C55 10.6406 43.3594 -1 29 -1V1ZM29 1V-1C14.6406 -1 3 10.6406 3 25H5H7C7 12.8497 16.8497 3 29 3V1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_468_10249)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3334 32.5V30.8333C32.3334 29.9493 31.9822 29.1014 31.3571 28.4763C30.732 27.8512 29.8841 27.5 29.0001 27.5H24.0001C23.116 27.5 22.2682 27.8512 21.6431 28.4763C21.0179 29.1014 20.6667 29.9493 20.6667 30.8333V32.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5001 24.1667C28.341 24.1667 29.8334 22.6743 29.8334 20.8333C29.8334 18.9924 28.341 17.5 26.5001 17.5C24.6591 17.5 23.1667 18.9924 23.1667 20.8333C23.1667 22.6743 24.6591 24.1667 26.5001 24.1667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 32.5001V30.8334C37.3327 30.0948 37.0869 29.3774 36.6344 28.7937C36.1819 28.2099 35.5484 27.793 34.8333 27.6084",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 17.6084C33.0503 17.792 33.6858 18.209 34.1396 18.7937C34.5935 19.3783 34.8398 20.0974 34.8398 20.8376C34.8398 21.5777 34.5935 22.2968 34.1396 22.8815C33.6858 23.4661 33.0503 23.8831 32.3333 24.0667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_468_10249",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_468_10249"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_10249"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_468_10249"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_468_10249",
    result: "effect2_dropShadow_468_10249"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_468_10249",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_10249",
    x1: 5,
    y1: 1,
    x2: 53,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.903d100e3e324306ea22f2355c51cb39.svg";
export { ForwardRef as ReactComponent };